import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';

import * as actions from '../../../redux/actions';

// components
export default function CardProfile({
  first_name,
  last_name,
  department,
  position,
  email,
  phone_number,
  address,
  postcode,
  image,
  id,
  verified_status,
}) {
  const dispatch = useDispatch();

  const handleUserVerified = () => {
    const confirm = window.confirm('ยืนยันการยืนยันผู้ใช้งาน');
    if (confirm) {
      const commandPayload = { employee_verified: true };
      dispatch(actions.employeeEdit(id, commandPayload)).then(() => {
        dispatch(actions.employeeGet(id));
      });
    }
  };

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg mt-16">
        <div className="px-\">
          <div className="flex flex-wrap justify-center">
            <div className="w-full px-4 flex justify-center">
              <div className="relative">
                {image ? (
                  <>
                    <img
                      alt="..."
                      src={image}
                      className="shadow-xl rounded-full h-auto align-middle border-none -m-16 -ml-20 lg:-ml-16 max-w-150-px"
                    />
                  </>
                ) : (
                  <>
                    {' '}
                    <img
                      alt="..."
                      src={require('assets/img/favicon-eappsoft.png')}
                      className="shadow-xl rounded-full h-auto align-middle border-none -m-16 -ml-20 lg:-ml-16 max-w-150-px"
                    />
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="text-center mt-20">
            <h3 className="text-xl font-semibold leading-normal mb-2 text-gray-800 mb-2">
              {first_name + ' ' + last_name}
            </h3>
            <div className="text-sm leading-normal mt-0 mb-2 text-gray-500 font-bold uppercase">
              {/* <i className="fas fa-briefcase  mr-2 text-lg text-gray-500"></i>{" "} */}
              <h4>แผนก : {department}</h4>
            </div>
            <div className="mb-2 text-gray-700 ">
              {/* <i className="fas fa-building mr-2 text-lg text-gray-500"></i> */}
              <h4>ตำแหน่ง : {position}</h4>
            </div>
          </div>
          <div className="w-full px-4 text-center mt-4">
            <div className="flex flex-wrap justify-center py-4 lg:pt-4 pt-8">
              <div className="lg:mr-4 p-3 text-center">
                <i className="fa fa-phone"></i>
                <span className="text-sm font-bold block uppercase tracking-wide text-gray-700">
                  เบอร์โทรศัพท์ : {phone_number}
                </span>
                <span className="text-sm text-gray-500"> </span>
              </div>
              <div className="mr-4 p-3 text-center">
                <i className="fa fa-mail-bulk fa-1x"></i>
                <span className="text-sm font-bold block uppercase tracking-wide text-gray-700">
                  อีเมล : {email}
                </span>
                <span className="text-sm text-gray-500"> </span>
              </div>
            </div>
          </div>
          <div className="mt-10 py-10 border-t border-gray-300 text-center">
            <div className="flex flex-wrap justify-center">
              <div className="w-full lg:w-9/12 px-4">
                <p className="mb-4 text-sm leading-relaxed text-gray-800">
                  ที่อยู่ : {address}
                </p>
              </div>
            </div>
            {verified_status === false && (
              <div className="flex flex-wrap justify-center">
                <Button
                  colorScheme="green"
                  onClick={() => handleUserVerified()}
                >
                  ยืนยันผู้ใช้งานคนนี้
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

CardProfile.defaultProps = {
  first_name: 'ชื่อ',
  last_name: 'สกุล',
  department: 'แผนก',
  position: 'ตำแหน่ง',
  email: 'อีเมล',
  phone_number: 'เบอร์โทรศัพท์',
  address: 'ที่อยู่',
  postcode: 'รหัสไปรษณีย์',
  image: null,
  id: '',
  verified_status: false,
};

CardProfile.propTypes = {
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  department: PropTypes.string,
  position: PropTypes.string,
  email: PropTypes.string,
  phone_number: PropTypes.string,
  address: PropTypes.string,
  postcode: PropTypes.string,
  image: PropTypes.string,
  id: PropTypes.string,
  verified_status: PropTypes.bool,
};
